import React from 'react';
import { SkeletonRect, SkeletonText, SkeletonButton, SkeletonPill } from '../../../common/Skeleton';

const QuestionFormSkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Question Text Textarea Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-28']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-24" rounded="md" />
      </div>

      {/* Tags Section Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-16']} height="h-4" />
        </div>
        <div className="flex flex-wrap gap-2">
          <SkeletonPill width="w-20" height="h-8" />
          <SkeletonPill width="w-24" height="h-8" />
          <SkeletonPill width="w-16" height="h-8" />
        </div>
      </div>

      {/* Answer Options Section Skeleton */}
      <div>
        <div className="flex justify-between items-center mb-2">
          <SkeletonText widths={['w-32']} height="h-4" />
          <SkeletonButton width="w-24" height="h-7" rounded="md" />
        </div>
        <div className="space-y-3">
          {/* Option 1 Skeleton */}
          <div className="flex gap-3 items-center">
            <div className="flex-1">
              <SkeletonRect width="w-full" height="h-10" rounded="md" />
            </div>
            <div className="w-24">
              <SkeletonRect width="w-full" height="h-10" rounded="md" />
            </div>
          </div>
          {/* Option 2 Skeleton */}
          <div className="flex gap-3 items-center">
            <div className="flex-1">
              <SkeletonRect width="w-full" height="h-10" rounded="md" />
            </div>
            <div className="w-24">
              <SkeletonRect width="w-full" height="h-10" rounded="md" />
            </div>
          </div>
          {/* Option 3 Skeleton */}
          <div className="flex gap-3 items-center">
            <div className="flex-1">
              <SkeletonRect width="w-full" height="h-10" rounded="md" />
            </div>
            <div className="w-24">
              <SkeletonRect width="w-full" height="h-10" rounded="md" />
            </div>
            <SkeletonRect width="w-10" height="h-10" rounded="full" />
          </div>
        </div>
      </div>

      {/* Buttons Skeleton */}
      <div className="flex gap-3 mt-6">
        <SkeletonButton width="flex-1" height="h-10" rounded="md" />
        <SkeletonButton width="flex-1" height="h-10" rounded="md" />
      </div>
    </div>
  );
};

export default QuestionFormSkeleton;
